import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api';
import './Auth.css';

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // Если есть token — форма нового пароля, иначе — форма запроса
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleForgot = async (e) => {
    e.preventDefault();
    setError(''); setMessage('');
    setLoading(true);
    try {
      const res = await api.post('/auth/forgot-password', { email });
      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Ошибка');
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(''); setMessage('');
    if (password !== confirm) { setError('Пароли не совпадают'); return; }
    setLoading(true);
    try {
      const res = await api.post('/auth/reset-password', { token, password });
      setMessage(res.data.message);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error?.message || 'Ошибка');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">{token ? '🔑' : '📧'}</div>
        <h1>{token ? 'Новый пароль' : 'Восстановление пароля'}</h1>
        <p className="auth-subtitle">
          {token ? 'Введите новый пароль' : 'Укажите email и мы отправим ссылку для сброса'}
        </p>

        {message && <div className="auth-error" style={{ background: '#e8f5e9', color: '#2e7d32', borderColor: '#c8e6c9' }}>{message}</div>}
        {error && <div className="auth-error">{error}</div>}

        {token ? (
          <form onSubmit={handleReset}>
            <div className="auth-field">
              <label>Новый пароль</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Минимум 6 символов" required />
            </div>
            <div className="auth-field">
              <label>Подтвердите пароль</label>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Повторите пароль" required />
            </div>
            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? 'Сохраняем...' : 'Сохранить пароль'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleForgot}>
            <div className="auth-field">
              <label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Ваш email" required />
            </div>
            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? 'Отправляем...' : 'Отправить ссылку'}
            </button>
          </form>
        )}

        <div className="auth-link">
          <Link to="/login">Назад к входу</Link>
        </div>
      </div>
    </div>
  );
}
